module.exports = __webpack_public_path__ + "static/media/coupon.72411f3e.svg";